import { FETCH_ERRORS_COUNT } from '../actions/types'

const initialState = 0

export const logsErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ERRORS_COUNT:
      return action.payload
    default:
      return state
  }
}
